import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StyledLabel, SimpleSelectSearch } from '../../FormElements';
import { useTranslation } from 'react-i18next';

const YearsPicker = ({
  title,
  maxYear,
  minYear,
  value,
  onChange,
  useAcademicFormat = false,
}) => {
  const { t } = useTranslation();
  const yearsOptions = useMemo(() => {
    let options = [];
    for (let i = minYear; i < maxYear + 1; i++) {
      options.push({
        name: useAcademicFormat ? `${i}/${i + 1}` : i,
        value: i,
      });
    }
    options.sort((a, b) => {
      if (a.value > b.value) return -1;
      if (a.value < b.value) return 1;
      return 0;
    });

    return options || [];
  }, [maxYear, minYear, useAcademicFormat]);

  return (
    <div style={{ marginBottom: 8 }}>
      <StyledLabel>{title}</StyledLabel>
      <SimpleSelectSearch
        onChange={onChange}
        options={yearsOptions}
        value={value}
      />
    </div>
  );
};

YearsPicker.propTypes = {
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
  value: PropTypes.number,
  useAcademicFormat: PropTypes.bool,
  onChange: PropTypes.any,
};

export default YearsPicker;
